import React, { useState } from "react";
import product1 from '../assets/image/product1.png'; // Import the product images
import product2 from '../assets/image/product2.jpg';
import product3 from '../assets/image/product3.jpg';
import product4 from '../assets/image/product4.jpg';
import product5 from '../assets/image/product5.jpg';
import product6 from '../assets/image/product6.jpg';
import product7 from '../assets/image/product7.jpg';
import product8 from '../assets/image/product8.jpg';

// Sample product data with quantity
const products = [
  { id: 1, name: "MS Steel Plate", category: "Electronics", description: "High-quality steel plates for your business needs.", price: "LKR 100", quantity: 20, image: product1 },
  { id: 2, name: "Heavy Duty Safety Gear", category: "Furniture", description: "Durable safety gear for work environments.", price: "LKR 150", quantity: 15, image: product2 },
  { id: 3, name: "Industrial Steam Pipes", category: "Apparel", description: "Trendy and comfortable apparel for modern needs.", price: "LKR 200", quantity: 10, image: product3 },
  { id: 4, name: "Innovative Electronics", category: "Electronics", description: "Latest gadgets to enhance your lifestyle.", price: "LKR 120", quantity: 30, image: product4 },
  { id: 5, name: "Elegant Office Furniture", category: "Furniture", description: "Stylish and functional furniture solutions.", price: "LKR 250", quantity: 25, image: product5 },
  { id: 6, name: "Advanced Welding Equipment", category: "Electronics", description: "Top-of-the-line welding tools for professionals.", price: "LKR 180", quantity: 10, image: product6 },
  { id: 7, name: "Fashionable Apparel", category: "Apparel", description: "Modern fashion for every occasion.", price: "LKR 120", quantity: 5, image: product7 },
  { id: 8, name: "Premium Office Chairs", category: "Furniture", description: "Comfortable seating solutions for office use.", price: "LKR 220", quantity: 18, image: product8 },
];

const categories = ["All", "Electronics", "Furniture", "Apparel"];

// Modal Component Definition
const Modal = ({ product, onClose }) => {
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.7)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000
    }}>
      <div style={{
        backgroundColor: "#fff", padding: "25px", borderRadius: "15px", width: "80%", maxWidth: "500px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)"
      }}>
        <h2 style={{ fontSize: "24px", color: "#333", marginBottom: "20px" }}>{product.name}</h2>
        <img src={product.image} alt={product.name} style={{ width: "100%", borderRadius: "10px", marginBottom: "15px" }} />
        <p><strong>Description:</strong> {product.description}</p>
        <p><strong>Price:</strong> {product.price}</p>
        <p><strong>Available Quantity:</strong> {product.quantity}</p>
        <button onClick={onClose} style={{
          padding: "12px 25px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", marginTop: "20px"
        }}>Close</button>
      </div>
    </div>
  );
};

const ShopPage = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [visibleProducts, setVisibleProducts] = useState(4); // initially show 4 products
  const [loading, setLoading] = useState(false);
  const [productsPerPage, setProductsPerPage] = useState(4); // for customizing the number of products

  const filteredProducts = activeCategory === "All"
    ? products
    : products.filter((product) => product.category === activeCategory);

  const loadMoreProducts = () => {
    setLoading(true);
    setTimeout(() => {
      setVisibleProducts(visibleProducts + productsPerPage); // Show more products based on the selected value
      setLoading(false);
    }, 1000); // Simulate loading time
  };

  const openModal = (product) => {
    setSelectedProduct(product);
  };

  const closeModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", textAlign: "center", padding: "20px", backgroundColor: "#f8f8f8" }}>
      <h1 style={{ fontSize: "36px", color: "#333", marginBottom: "20px" }}>Shop</h1>
      <p style={{ fontSize: "18px", color: "#555", marginBottom: "40px" }}>Browse our wide range of top-quality products across various categories.</p>

      {/* Category Filter */}
      <div style={{ display: "flex", justifyContent: "center", gap: "15px", marginBottom: "40px" }}>
        {categories.map((category) => (
          <button
            key={category}
            style={{
              padding: "12px 25px", fontSize: "16px", fontWeight: "bold", backgroundColor: activeCategory === category ? "#007bff" : "#f1f1f1", color: activeCategory === category ? "#fff" : "#333", border: "none", borderRadius: "30px", cursor: "pointer", transition: "all 0.3s ease"
            }}
            onClick={() => setActiveCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Products Per Page Selector */}
      <div style={{ marginBottom: "20px" }}>
        <label htmlFor="productsPerPage" style={{ fontSize: "18px", color: "#555", marginRight: "10px" }}>
          Products per Page:
        </label>
        <select
          id="productsPerPage"
          value={productsPerPage}
          onChange={(e) => setProductsPerPage(Number(e.target.value))}
          style={{
            padding: "8px", fontSize: "16px", borderRadius: "5px", border: "1px solid #ddd", cursor: "pointer"
          }}
        >
          <option value="4">4</option>
          <option value="8">8</option>
          <option value="12">12</option>
        </select>
      </div>

      {/* Product List */}
      <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
        {filteredProducts.slice(0, visibleProducts).map((product) => (
          <div key={product.id} style={{
            width: "300px", backgroundColor: "#fff", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "20px", textAlign: "center", transition: "transform 0.3s ease, box-shadow 0.3s ease",
            cursor: "pointer"
          }}
            onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"} onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}>
            <img
              src={product.image}
              alt={product.name}
              style={{
                width: "100%",
                height: "200px",  // Fixed height for all images
                objectFit: "cover", // Ensures the image fits within the specified width and height
                borderRadius: "10px",
                marginBottom: "15px",
                transition: "transform 0.3s ease"
              }} />
            <h3 style={{ fontSize: "20px", margin: "10px 0", color: "#007bff" }}>{product.name}</h3>
            <p style={{ fontSize: "16px", color: "#555", marginBottom: "15px" }}>{product.description}</p>
            <p style={{ fontSize: "18px", color: "#007bff", fontWeight: "bold" }}>{product.price}</p>
            <button
              onClick={() => openModal(product)}
              style={{
                display: "inline-block", padding: "10px 20px", backgroundColor: "#007bff", color: "#fff", borderRadius: "5px", cursor: "pointer", textDecoration: "none", transition: "background-color 0.3s ease"
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#0056b3")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#007bff")}
            >
              View Details
            </button>
          </div>
        ))}
      </div>

      {/* "View More" Button */}
      <div style={{ marginTop: "20px" }}>
        <button
          onClick={loadMoreProducts}
          style={{
            padding: "12px 30px", backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "8px", fontSize: "18px", cursor: "pointer", transition: "all 0.3s ease"
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#218838")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#28a745")}
        >
          {loading ? "Loading..." : "View More Products"}
        </button>
      </div>

      {/* Modal for product details */}
      {selectedProduct && (
        <Modal
          product={selectedProduct}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default ShopPage;
